// src/icons/svgs/tooltip-edit.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgTooltipEdit = (props, ref) => /* @__PURE__ */ jsx("svg", { fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "#343A40", fillRule: "evenodd", d: "M14 3.891C8.417 3.891 3.89 8.417 3.89 14S8.417 24.109 14 24.109s10.109-4.526 10.109-10.11c0-5.582-4.526-10.108-10.11-10.108ZM2.33 14C2.331 7.555 7.555 2.33 14 2.33S25.669 7.555 25.669 14s-5.224 11.669-11.67 11.669c-6.444 0-11.668-5.224-11.668-11.67Zm11.673 5.447c.43 0 .78-.35.78-.78v-5.445a.78.78 0 1 0-1.56 0v5.445c0 .43.35.78.78.78m0-10.89a1.166 1.166 0 1 1 0 2.333 1.166 1.166 0 0 1 0-2.332Z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgTooltipEdit);
var tooltip_edit_default = ForwardRef;
export {
  tooltip_edit_default as TooltipEdit
};
